import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '@/components/header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ExtractStructureWithDataset from '@/routes/(app)/(tasks)/components/extract-structure-with-dataset';
import ExtractStructureWithFile from '@/routes/(app)/(tasks)/components/extract-structure-with-file';

const ExtractStructureTab = {
  WITH_FILE: 'extract-structure-with-file',
  WITH_DATASET: 'extract-structure-with-dataset',
} as const;

const ExtractStructure = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header
        title={t(`tasks.extractStructure.title`)}
        description={t(`tasks.extractStructure.description`)}
      />

      <Tabs defaultValue={ExtractStructureTab.WITH_DATASET}>
        <TabsList>
          <TabsTrigger value={ExtractStructureTab.WITH_DATASET}>
            {t('tasks.extractStructure.withDataset.title')}
          </TabsTrigger>
          <TabsTrigger value={ExtractStructureTab.WITH_FILE}>
            {t('tasks.extractStructure.withFile.title')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value={ExtractStructureTab.WITH_DATASET}>
          <ExtractStructureWithDataset />
        </TabsContent>
        <TabsContent value={ExtractStructureTab.WITH_FILE}>
          <ExtractStructureWithFile />
        </TabsContent>
      </Tabs>
    </>
  );
};

export default ExtractStructure;
